import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import moment from 'moment';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import translationEN from '../locales/en/translation.json';
import translationEnUS from '../locales/en-US/translation.json';
import translationFR from '../locales/fr/translation.json';
import translationES from '../locales/es/translation.json';

const supportedLngs = ['fr', 'es', 'en', 'en-US'];
const resources = {
  en: {
    translation: translationEN,
  },
  'en-US': {
    translation: translationEnUS,
  },
  fr: {
    translation: translationFR,
  },
  es: {
    translation: translationES,
  },
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    detection: {
      // To allow fallback if browser language is similar to supported langs
      // es-AR -> es or en-US to en
      checkForSimilarInWhitelist: true,
    },
    fallbackLng: 'en',
    debug: false,
    load: 'currentOnly',
    returnEmptyString: false, // Parser returns empty value string, so we need to return the keys
    returnNull: false,
    nsSeparator: false, // Disable separators since we are not using keys
    keySeparator: false,
    supportedLngs,
    whitelist: supportedLngs,
    interpolation: {
      escapeValue: false,
      format: (value, format, lng) => {
        // This is to format the dates using moment
        if (value instanceof Date) return moment(value).format(format);
        return value;
      },
    },
  });

export default i18n;
